import React, { useMemo } from 'react';

import Show from 'components/Show';
import Pill from 'components/Misc/Pill';
import Avatar from 'components/Misc/Avatar';
import { DefaultMark } from 'components/Ui/Mark';
import { Title } from 'components/Misc/Typography';
import { Button, Datepicker } from 'components/Misc/Form';

import { EXAM_STUDENT_STATES } from 'utils/Constants';

import Checker from 'containers/Administrator/Courses/Profile/Students/Checker';

import { useCourseStudentsStore } from 'store/course/useCourseStudentsStore';

const Student = ({ relation }) => {
	// Use students store
	const [isSelected, onChange] = useCourseStudentsStore(state => [
		(state.data.selected.find(id => id === relation.student.id) || state.data.all) && !state.data.deselected.find(id => id === relation.student.id),
		state.onSelect
	]);

	// Find latest take
	const latest = useMemo(() => {
		return relation?.student?.takes?.sort((a, b) => a.id - b.id)?.[0] ?? {};
	}, [relation]);

	// Find status info
	const state = useMemo(() => EXAM_STUDENT_STATES.find(state => state.value === latest?.state), [latest]);

	return (
		<tr>
			<td className="pl-3 py-2 text-neutral-700">
				<Checker
					name={relation.student.id}
					value={isSelected}
					onChange={onChange}
				/>
			</td>

			<td className="px-3 py-2 text-neutral-700 w-full">
				<div className="flex items-center space-x-2">
					<Avatar
						small
						src={relation.student.avatar}
						alt={relation.student.fullName}
						online={relation.student.online}
					/>

					<Title
						title={relation.student.fullName}
						className="flex-1"
					/>
				</div>
			</td>

			<td className="px-3 py-2 text-neutral-700">
				<Datepicker
					readOnly
					value={relation.startDate}
				/>
			</td>

			<td className="px-3 py-2 text-neutral-700">
				<Datepicker
					end
					readOnly
					value={relation.endDate}
				/>
			</td>

			<td className="px-3 py-2 text-neutral-700">
				<Show if={state}>
					<Pill
						name={state?.text}
						theme={state?.theme}
					/>
				</Show>
			</td>

			<td className="px-3 py-2 text-neutral-700">
				<Show if={latest?.id}>
					<DefaultMark take={latest} />
				</Show>
			</td>

			<td className="pr-3 py-2 text-neutral-700">
				<Button
					small
					square
					icon="link"
					to={`/users/${relation.student.id}`}
				/>
			</td>
		</tr>
	);
};

export default Student;